import { BusinessHourApiModel } from '../../models/businessHour.model';
import BaseApi from './BaseApi';

export type CompanyProfile = {
  fileData?: File;
  body?: {
    name?: string;
    useAutoResponse?: boolean;
    autoResponse?: string;
    useThanksMessage?: boolean;
    thanksMessage?: string;
    activeTime?: BusinessHourApiModel;
    lastActiveTime?: BusinessHourApiModel;  //休業日（activeTime=null）でも直近の営業時間を保持する
    noticeMail?: string[];
    bucketName: string;
  };
};

/**
 * プロフィール変更API。
 */
class UpdateCompanyProfileApi extends BaseApi {
  async send(details: CompanyProfile) {
    const formData = this.buildFormData(details);
    return await this.execute(
      'updateCompanyProfileApi',
      {
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        body: formData
      },
      true
    ).then(({ status }) => status === 1);
  }
}

export default UpdateCompanyProfileApi;
